import { toast } from "sonner";

// Shown after a Revise with AI finalize that saved the work step but did not
// apply some drafted attribute links (the backend's dropped_attribute_links):
// another kind of column, such as an Analytics column, already answers that
// attribute, and an attribute is answered by one kind only. Each reason names
// the attribute and both columns, so it is shown as the backend wrote it.
export const toastDroppedAttributeLinks = (reasons: string[]) => {
  if (reasons.length === 0) return;
  toast.warning(
    reasons.length === 1
      ? "One attribute link was not applied"
      : `${reasons.length} attribute links were not applied`,
    {
      description: (
        <div className="flex flex-col gap-2">
          {reasons.map((reason, index) => (
            <p key={index}>{reason}</p>
          ))}
        </div>
      ),
      duration: 15000,
    },
  );
};
